import React, { Component } from "react";
import styled from "styled-components";
import SignOut from "../components/SignOut";
import { breakpoints } from "../Media";
import { colors } from "../resources/ThemeColors";
import { connect } from "react-redux";

class Header extends Component {
  state = {};
  render() {
    const { isLoggedIn } = this.props;
    return isLoggedIn ? (
      <HeaderContainer>
        <LogoDiv>
          <Title href="/landing">HairQ</Title>
          <Tagline>Because Life Matters</Tagline>
        </LogoDiv>
        <NavLinksDiv>
          {/* <NavLink href="/">Home</NavLink> */}
          {/* <NavLink href="/about-tusomeni">About</NavLink> */}
          <SignOut />
          <NavLinks href="#bottom">
            <Buttons main>Get the App</Buttons>
          </NavLinks>
        </NavLinksDiv>
      </HeaderContainer>
    ) : (
      <HeaderContainer>
        <LogoDiv>
          <Title href="/landing">HairQ</Title>
          <Tagline>Because Life Matters</Tagline>
        </LogoDiv>
        <NavLinksDiv>
          <NavLink href="/login">
            <Button>Login</Button>
          </NavLink>
          <NavLink href="/signup">
            <Button>Sign Up</Button>
          </NavLink>
          <NavLink href="/login" mobileDisplay>
            <Button>Sign In</Button>
          </NavLink>
          <NavLinks href="#bottom">
            <Buttons main>Get the App</Buttons>
          </NavLinks>
        </NavLinksDiv>
      </HeaderContainer>
    );
  }
}

export const mapStateToProps = (state) => ({
  isLoggedIn: state.loginReducer.isLoggedIn,
});

export default connect(mapStateToProps, null)(Header);

const HeaderContainer = styled.div`
  height: auto;
  overflow: hidden;
  background-color: white;
  padding-left: 2em;
  padding-right: 0em;
  display: flex;
  flex-direction: row nowrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 1.5em;
  padding-bottom: 0.5em;
  position: sticky;
  top: 0;
  z-index: 1;

  @media (max-width: ${breakpoints.mobileMin}) {
    padding-right: 1em;
    padding-left: 1em;
    height: auto;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const LogoDiv = styled.div`
  left: 0;
  display: flex;
  flex-direction: row nowrap;
  align-items: center;
  justify-content: center;
  @media (max-width: ${breakpoints.mobileMin}) {
  }
`;

const Title = styled.a`
  text-decoration: none;
  font-style: normal;
  font-family: sans-serif;
  font-size: 1.6em;
  font-weight: 700;
  margin-left: 0.3em;
  color: ${colors.main};

  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1.1em;
  }
`;

const Tagline = styled.p`
  font-size: 0.7em;
  font-style: italicize;
  margin-left: 0.4em;
  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 0.5em;
  }
`;

const NavLinksDiv = styled.div`
  width: auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: space-evenly;
  justify-content: center;
  margin-right: 1em;

  @media (max-width: ${breakpoints.mobileMin}) {
    margin-right: 0.2em;
    width: 65%;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    margin-right: 2.5em;
  }
`;

const NavLink = styled.a`
  display: ${(props) => (props.mobileDisplay ? "none" : "flex")};
  font-size: 1.1em;
  font-weight: 400;
  font-family: sans-serif;
  text-decoration: none;
  color: ${colors.dark};
  margin-right: 1em;

  :hover {
    color: ${colors.main};
  }

  @media (max-width: ${breakpoints.mobileMin}) {
    margin-right: 0.2em;
    margin-left: 0.2em;
    display: ${(props) => (props.mobileDisplay ? "flex" : "none")};
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const Button = styled.button`
  height: 2.5em;
  width: 8em;
  color: ${(props) => (props.main ? "white" : "#23049d")};
  font-weight: 600;
  background-color: ${(props) => (props.main ? "#23049d" : "white")};
  margin-right: 1em;
  border: 1px solid #23049d;
  border-radius: 4px;
  cursor: pointer;
  :focus {
    outline: none;
  }

  @media (max-width: ${breakpoints.mobileMin}) {
    margin-right: 0.2em;
    width: 5em;
    text-align: justify;
  }
`;

const NavLinks = styled.a`
  font-size: 1.1em;
  font-weight: 400;
  font-family: sans-serif;
  text-decoration: none;
  color: ${colors.dark};
  margin-right: 1em;

  :hover {
    color: ${colors.main};
  }

  @media (max-width: ${breakpoints.mobileMin}) {
    margin-right: 0.1em;
    margin-left: 0.2em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const Buttons = styled.button`
  height: 2.5em;
  width: 8em;
  color: ${(props) => (props.main ? "white" : "#23049d")};
  font-weight: 600;
  background-color: ${(props) => (props.main ? "#23049d" : "white")};
  margin-right: 1em;
  border: 1px solid #23049d;
  border-radius: 4px;
  cursor: pointer;
  :focus {
    outline: none;
  }

  @media (max-width: ${breakpoints.mobileMin}) {
    margin-right: 0.1em;
    width: 7em;
  }
`;
